/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Publish_2_TitleInputs */

const en_mk_publish_2_title = /** @type {(inputs: Mk_Publish_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish & monitor`)
};

const id_mk_publish_2_title = /** @type {(inputs: Mk_Publish_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terbitkan & pantau`)
};

/**
* | output |
* | --- |
* | "Publish & monitor" |
*
* @param {Mk_Publish_2_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_publish_2_title = /** @type {((inputs?: Mk_Publish_2_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Publish_2_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_publish_2_title(inputs)
	return en_mk_publish_2_title(inputs)
});